import * as moment from 'moment';

export class DepartureTimeHelper {
  private static ONE_HOUR_MS = 60 * 60 * 1000;

  static toUtc(departureTime: Date): moment.Moment {
    return moment.utc(moment(departureTime).format('YYYY-MM-DDTHH:mm:ss'));
  }

  static getRemainingTimeMs(departureTime: Date): number {
    return this.toUtc(departureTime).diff(moment.utc());
  }

  static isMoreThenOneHourLeft(departureTime: Date): boolean {
    return this.getRemainingTimeMs(departureTime) >= this.ONE_HOUR_MS;
  }

  static isLessThenOneHourLeft(departureTime: Date): boolean {
    return this.getRemainingTimeMs(departureTime) <= this.ONE_HOUR_MS;
  }

  static calculateNewExpirationDate(departureTime: Date): string {
    const remainingMs = this.getRemainingTimeMs(departureTime);

    const moreThan1h = remainingMs > this.ONE_HOUR_MS;
    const lessThan24h = remainingMs <= 24 * this.ONE_HOUR_MS;

    const newDate = (lessThan24h && moreThan1h)
      ? this.toUtc(departureTime).clone().subtract(1, 'hour')
      : moment.utc().add(24, 'hours');

    return newDate.format('YYYY-MM-DDTHH:mm:ss');
  }

  static getExtendingHours(departureTime: Date): number {
    const remainingTime = this.getRemainingTimeMs(departureTime);
    return remainingTime < 24 * this.ONE_HOUR_MS
      ? Math.floor(remainingTime / this.ONE_HOUR_MS)
      : 24;
  }
}
